// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.storage_SwitchField_container__Sb3L- {
  display: flex;
  align-items: center;
  gap: 8px;
}

.storage_SwitchField_label__NacPR {
  color: var(--color-black);
  font-size: 14px;
}

.storage_SwitchField_containerDisabled__9jtqM {
  pointer-events: none;
}

.storage_SwitchField_switch__BSjQc {
  width: 35px !important;
  height: 18px !important;
  padding: 0 !important;
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-switchBase {
  padding: 2px;
  transition-duration: 200ms;
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-thumb {
  width: 14px;
  height: 14px;
  background-color: var(--color-grey-06);
  box-shadow: none;
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-track {
  box-sizing: border-box;
  border: 1px solid var(--color-grey-04);
  border-radius: 20px;
  background-color: var(--color-white);
  opacity: 1 !important;
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-switchBase.Mui-checked {
  transform: translateX(17px);
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {
  border: 1px solid var(--color-grey-09);
  background-color: var(--color-pop-green);
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb {
  background-color: var(--color-grey-09);
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track {
  border: 1px solid var(--color-grey-04);
  background-color: var(--color-white);
  opacity: 0.4;
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb {
  background-color: var(--color-grey-04);
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track {
  border: 1px solid var(--color-grey-04);
  background-color: var(--color-light-green);
  opacity: 1;
}

.storage_SwitchField_switch__BSjQc .MuiSwitch-switchBase.Mui-checked.Mui-disabled .MuiSwitch-thumb {
  background-color: var(--color-grey-04);
}
`, "",{"version":3,"sources":["webpack://./src/components/SwitchField/SwitchField.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;EACtC,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sCAAsC;EACtC,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;EAC1C,UAAU;AACZ;;AAEA;EACE,sCAAsC;AACxC","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.label {\n  color: var(--color-black);\n  font-size: 14px;\n}\n\n.containerDisabled {\n  pointer-events: none;\n}\n\n.switch {\n  width: 35px !important;\n  height: 18px !important;\n  padding: 0 !important;\n}\n\n.switch :global(.MuiSwitch-switchBase) {\n  padding: 2px;\n  transition-duration: 200ms;\n}\n\n.switch :global(.MuiSwitch-thumb) {\n  width: 14px;\n  height: 14px;\n  background-color: var(--color-grey-06);\n  box-shadow: none;\n}\n\n.switch :global(.MuiSwitch-track) {\n  box-sizing: border-box;\n  border: 1px solid var(--color-grey-04);\n  border-radius: 20px;\n  background-color: var(--color-white);\n  opacity: 1 !important;\n}\n\n.switch :global(.MuiSwitch-switchBase.Mui-checked) {\n  transform: translateX(17px);\n}\n\n.switch :global(.MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track) {\n  border: 1px solid var(--color-grey-09);\n  background-color: var(--color-pop-green);\n}\n\n.switch :global(.MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb) {\n  background-color: var(--color-grey-09);\n}\n\n.switch :global(.MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track) {\n  border: 1px solid var(--color-grey-04);\n  background-color: var(--color-white);\n  opacity: 0.4;\n}\n\n.switch :global(.MuiSwitch-switchBase.Mui-disabled .MuiSwitch-thumb) {\n  background-color: var(--color-grey-04);\n}\n\n.switch :global(.MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track) {\n  border: 1px solid var(--color-grey-04);\n  background-color: var(--color-light-green);\n  opacity: 1;\n}\n\n.switch :global(.MuiSwitch-switchBase.Mui-checked.Mui-disabled .MuiSwitch-thumb) {\n  background-color: var(--color-grey-04);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `storage_SwitchField_container__Sb3L-`,
	"label": `storage_SwitchField_label__NacPR`,
	"containerDisabled": `storage_SwitchField_containerDisabled__9jtqM`,
	"switch": `storage_SwitchField_switch__BSjQc`
};
export default ___CSS_LOADER_EXPORT___;
